export default __webpack_public_path__ + "static/media/SG-Yellow-0005.9b1da8ed.png";